// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"22db691c","127":"b85b59f2","134":"f8cc97a1"}[chunkId] + ".chunk.css";
};